import { useAuth } from '../contexts/AuthContext';
import type { LoginResponse } from '@pgway/shared';

export type MdrTier = 'master' | 'sub' | null;

type MaybeUser = LoginResponse['user'] | null | undefined;

/**
 * Resolves an MDR user's tier. Non-MDR roles get null. Backend `loadMdrScope`
 * is always the real authority; this only drives UI gating. See docs/mdr.md.
 */
export function resolveMdrTier(user: MaybeUser): MdrTier {
  if (!user || user.role !== 'mdr') return null;
  if (user.mdrTier === 'master' || user.mdrTier === 'sub') return user.mdrTier;
  return null;
}

/**
 * Current MDR user's tier + derived capability flags.
 * - isMaster:  manages sub-MDRs, groups, sub-assignments, payouts
 * - isSubMdr:  read-only view of assigned merchants + own share
 * - canManage: alias for isMaster (mutating actions)
 */
export function useMdr() {
  const { user } = useAuth();
  const tier = resolveMdrTier(user);
  return {
    tier,
    isMaster: tier === 'master',
    isSubMdr: tier === 'sub',
    canManage: tier === 'master',
  };
}
